import { getApiActionTypes } from '../storeHelpers';

export const fetchAccountLineItemDetailTypes = getApiActionTypes('FETCH_ACCOUNT_LINE_ITEM_DETAIL');
